import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { jwtDecode } from "jwt-decode";

const UserDashboard = () => {
  const navigate = useNavigate();
  const [user, setUser] = useState(null);

  useEffect(() => {
    const fetchUserData = async () => {
      try {
        const token = localStorage.getItem("token");
        if (!token) return;

        const decoded = jwtDecode(token);
        console.log(decoded);
        const userId = decoded.authUserId;

        const res = await axios.get(
          `https://api.happychd.com/api/user/${userId}`
        );
        setUser(res.data);
      } catch (error) {
        console.error("Failed to fetch user:", error.message);
      }
    };

    fetchUserData();
  }, []);

  const handleDeposit = () => navigate("/deposit");
  const handleWithdraw = () => navigate("/withdraw");
  const handleTransactions = () => navigate(`/user/transactions/${user._id}`);

  if (!user) {
    return (
      <div className="text-center py-20 text-gray-600">
        Loading user info...
      </div>
    );
  }

  return (
    <div className="flex flex-col items-center justify-center py-32 bg-gray-100 px-4">
      <div className="bg-white shadow-md rounded-lg p-6 w-full max-w-md text-center">
        <h2 className="text-2xl font-bold text-orange-500 mb-4">
          Welcome, {user.name}
        </h2>
        <p className="text-gray-700 mb-2">
          <strong>User ID:</strong> {user.userId}
        </p>
        <p className="text-gray-700 mb-6">
          <strong>Referred By:</strong> {user.referredBy?.name || "N/A"}
        </p>

        <div className="flex flex-wrap justify-center gap-4">
        
          <button
            onClick={handleTransactions}
            className="bg-blue-500 hover:bg-blue-600 text-white font-semibold px-6 py-2 rounded"
          >
            Transactions
          </button>
        </div>
      </div>
    </div>
  );
};

export default UserDashboard;
